<div>
    <div>
        {{ iStudentId}} - {{ strStudentName }}
    </div>
    <mat-form-field appearance="fill" class="theme-form-field">
        <mat-label>Marks</mat-label>
        <input type="number" matInput placeholder="" [formControl]="marksInputControl" (keyup.enter)="onEnter()" (focusout)="onFocusLost()" />
        <span class="error-message">{{strErrorMessage}}</span>
    </mat-form-field>
</div>